import React from 'react';
import './DayColumn.css';
import PropTypes from 'prop-types';
import {
    formatDateToDayName,
    getEstCel,
    tempMaxColor,
    tempMinColor,
} from '../../utils/utils';
import Loader from '../../partials/Loader/Loader';

const DayColumn = props => {
    const { data, config } = props;

    // Styles
    const estCelIcon = getEstCel(data.est_cel[props.index][0].valor);
    const iconStyle = { backgroundImage: `url(${estCelIcon})` };
    const tempMaxCol = { color: tempMaxColor(config.color) };
    const tempMinCol = { color: tempMinColor(config.color) };

    // Vars
    const tempMax = data.temp_max
        ? Math.round(data.temp_max[props.index][0].valor)
        : '';
    const tempMin = data.temp_min
        ? Math.round(data.temp_min[props.index][0].valor)
        : '';
    const probPrec = data.prob_prec
        ? Math.round(data.prob_prec[props.index][0].valor)
        : '';
    const unitatTemp = config.tempFormat || '°';
    const unitatProbPrec = data.prob_prec_unitat || '%';

    if (data.est_cel && props.index) {
        return (
            <div className="mc-widget-day mc-widget-daycol">
                <h3>
                    {formatDateToDayName(
                        data.est_cel[props.index][0].data,
                        config.language,
                        'short'
                    )}
                </h3>
                <div className="mc-widget-daycol__wrapper">
                    <div
                        className="mc-widget-daycol__icon"
                        style={iconStyle}
                        title="Sol i pluja"
                    />
                    {(tempMax || tempMax === 0) && (
                        <div className="mc-widget-daycol__temp-max">
                            <span style={tempMaxCol}>
                                {tempMax}
                                {unitatTemp}
                            </span>
                        </div>
                    )}
                    {(tempMin || tempMin === 0) && (
                        <div className="mc-widget-daycol__temp-min">
                            <span style={tempMinCol}>
                                {tempMin}
                                {unitatTemp}
                            </span>
                        </div>
                    )}
                    {(probPrec || probPrec === 0) && (
                        <div className="mc-widget-daycol__rain">
                            {probPrec}
                            {unitatProbPrec}
                        </div>
                    )}
                </div>
            </div>
        );
    } else {
        return <Loader language={this.state.config.language} />;
    }
};

DayColumn.propTypes = {
    config: PropTypes.shape({
        alternativeTitle: PropTypes.string,
        color: PropTypes.string,
        language: PropTypes.string,
        location: PropTypes.string,
        type: PropTypes.string,
        variables: PropTypes.arrayOf(PropTypes.string),
    }),
    data: PropTypes.object,
    index: PropTypes.number,
};

export default DayColumn;



// WEBPACK FOOTER //
// ./src/partials/DayColumn/DayColumn.js